<template>
    <div class="com-part1">
		<title1 type="1" title="能源监测" style="margin-top: 30px" />
        <div class="pue-list flex align-center mt-100">
            <div
                v-for="(item, i) in pueList" :key="'pueList' + i"
                class="flex1 pue-item flex flex-direction align-center">
                <p class="label">{{ item.label }}</p>
                <p class="value mt-10">{{ item.value }}</p>
                <p class="unit mt_10">{{ item.unit }}</p>
            </div>
        </div>
        <!-- 原设计图 -->
        <!-- <MyTitle class="mt-20" type="2" title="实时IT负载" /> -->
        <!-- <div class="p-content flex align-center">
            <myEchart
                v-if="showBatteryCharging"
                :id="'showBatteryCharging'"
                :options="batteryChargingData" />
        </div> -->
    </div>
</template>

<script>
import title1 from '@/views/exposition/components/title1'
// import myEchart from "./charts/echarts"
import { dataInterface } from "@/api/dataInterfaceApi"
import { formatTime } from '@/utils/index'
export default {
    components: {
        title1,
        // myEchart
    },
    data() {
        return {
            pueList: [
                {
                    label: '总能耗',
                    value: '590',
                    unit: 'kW'
                },
                {
                    label: 'IT能耗',
                    value: '590',
                    unit: 'kW'
                },
                {
                    label: 'PUE',
                    value: '590',
                    unit: ''
                }
            ],
            // 充电参数实时检测
            showBatteryCharging: false,
            batteryChargingData: {}
        }
    },
	mounted() {
        // 充电参数实时检测
        this.getbatteryCharging()
    },
	methods: {
        // 能源监测
        getbatteryCharging() {
          let params = { 
            enCode: 'computingpower-left-nhjc',
          }
          dataInterface.dataFaceApi(params).then(res => {
            console.log(res, '能源监测')
            this.pueList[0].value = res[0].total_energy || 0
            this.pueList[1].value = res[0].it_energy || 0
            this.pueList[2].value = res[0].pue || 0
          })
        }
    }
}
</script>

<style lang="scss" scoped>
@import '../comm.scss';
.com-part1 {
    width: 100%;
    height: 486px;
    .pue-list {
        height: 235px;
        .pue-item {
            height: 100%;
            background: url(~@/assets/images/computility/dispatch-icon5.png) center no-repeat;
            background-size: 220px 216px;
            animation: breath_light 3s ease infinite;
            > p {
                display: flex;
                // align-items: center;
                justify-content: center;
                font-size: $FontSize24;
            }
            .label {
                height: 50px;
                font-size: $FontSize36;
            }
            .value {
                font-family: 'DS-Digital-Bold';
                font-size: $FontSize45;
            }
        }
    }
    .p-content {
        width: 100%;
        height: 320px;
    }
}
</style>